// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 141) return "static/chunks/141-62fa7fb930001b07.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1761":"d0deef33","2000":"e99863e0","2666":"fcfb803e"}[chunkId] || chunkId) + "." + {"1761":"d479a23977939e0c","2000":"36a3de7326bb7ec9","2666":"00ca0e0d973ed6aa","7722":"8be7202c8fa9268e","8397":"c22bd2e15c2bc322","9163":"48a2b36c97dcbf05"}[chunkId] + ".js";
};